import { createAsyncThunk } from '@reduxjs/toolkit';

import { marketPrice } from 'src/api';

export const getMarketPrice = createAsyncThunk('marketPrice/getMarketPrice', async (params: any, thunkAPI) => {
  try {
    const response = await marketPrice.getMarketPrice(params);

    if (response.status === 401) {
      return thunkAPI.rejectWithValue('401 Unauthorized');
    }

    if (!response.ok) {
      const json = await response.json();

      return thunkAPI.rejectWithValue(json);
    }

    return await response.json();
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error);
  }
});
